<template>
	<div class="lista-rentabilidade-ativo">
		<table class="table table-ativos" :class="{ dark: dark }">
			<!-- <caption>Rentabilidade dos ativos</caption> -->
			<thead class="text-custom primary">
				<tr>
					<th class="px-0">#</th>
					<th>Ativos</th>
					<th class="text-right">Rent. mês</th>
					<th class="text-right">Rent. ano</th>
					<th class="text-right">Rent. 12 meses</th>
					<th class="text-right">Rent. 24 meses</th>
					<th class="text-right">Rent. 36 meses</th>
					<!-- <th class="text-right">Rentabilidade desde o início</th> -->
					<th class="text-right"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in ativos" v-bind:key="index">
					<td :title="item.nomeAtivo" colspan="2">
						<div class="d-flex align-items-center">
							<span class="color-ball" :style=" {background: item.cor}"></span>
							<p class="mb-0">{{ item.nomeAtivo }}</p>
						</div>
					</td>
					<td class="text-right">
						<div>
							<img v-if="item.rentabilidadeMes !== 0" :src="iconeStonksParaValor(item.rentabilidadeMes)" alt="..." class="md-financial-icon"/>
							<span :class="{'negative': item.rentabilidadeMes < 0}">{{ formatarPorcentagem(item.rentabilidadeMes) }}</span>
						</div>
					</td>
					<td class="text-right">
						<div>
							<img v-if="item.rentabilidadeAno !== 0" :src="iconeStonksParaValor(item.rentabilidadeAno)" alt="..." class="md-financial-icon"/>
							<span :class="{'negative': item.rentabilidadeAno < 0}">{{ formatarPorcentagem(item.rentabilidadeAno) }}</span>
						</div>
					</td>
					<td class="text-right">
						<div>
							<img v-if="item.rentabilidade12Meses !== 0" :src="iconeStonksParaValor(item.rentabilidade12Meses)" alt="..." class="md-financial-icon"/>
							<span :class="{'negative': item.rentabilidade12Meses < 0}">{{ formatarPorcentagem(item.rentabilidade12Meses) }}</span>
						</div>
					</td>
					<td class="text-right">
						<div>
							<img v-if="item.rentabilidade24Meses !== 0" :src="iconeStonksParaValor(item.rentabilidade24Meses)" alt="..." class="md-financial-icon"/>
							<span :class="{'negative': item.rentabilidade24Meses < 0}">{{ formatarPorcentagem(item.rentabilidade24Meses) }}</span>
						</div>
					</td>
					<td class="text-right">
						<div>
							<img v-if="item.rentabilidade36Meses !== 0" :src="iconeStonksParaValor(item.rentabilidade36Meses)" alt="..." class="md-financial-icon"/>
							<span :class="{'negative': item.rentabilidade36Meses < 0}">{{ formatarPorcentagem(item.rentabilidade36Meses) }}</span>
						</div>
					</td>
					<!-- <td class="text-right">
						<div>
							<img v-if="item.rentabilidadeDesdeInicio !== 0" :src="iconeStonksParaValor(item.rentabilidadeDesdeInicio)" alt="..." class="md-financial-icon"/>
							<span :class="{'negative': item.rentabilidadeDesdeInicio < 0}">{{ formatarPorcentagem(item.rentabilidadeDesdeInicio) }}</span>
						</div>
					</td> -->
					<td class="text-right">
						<span class="cursor-pointer" v-if="!desativarRemocaoIndexador(item.codigoAtivo)" >
							<img src="img/icons/ico-trash.svg" @click="confirmarRemocaoAtivo(item)">
						</span>
					</td>
				</tr>
			</tbody>
		</table>

		<sweet-modal ref="modalConfirmarRemocaoAtivo" blocking :modal-theme="modalTheme" :overlay-theme="modalTheme">
			<div class="modal-body">
				<p>Você tem certeza que deseja excluir o ativo {{ ativoSelecionado.nomeAtivo }}?</p>
			</div>
			<div class="d-flex flex-row justify-content-between mt-4">
				<button type="button" class="btn btn-custom tertiary text-custom secondary" :class="{ 'text-white': dark }" @click="$refs.modalConfirmarRemocaoAtivo.close()">Cancelar</button>
				<button type="button" class="btn btn-custom text-danger" @click="removerAtivo()">Remover</button>
			</div>
		</sweet-modal>
	</div>
</template>

<script>
import Vue from "vue"
import moment from "moment"
import { SweetModal } from "sweet-modal-vue"

import SpinnerService from "@/app/services/spinner.service"
import ColorsService from "@/app/services/colors.service"
import UtilsService from "@/app/services/utils.service"
import ComparadorService from "@/app/services/Comparador/comparador.service"

export default {
	components: {
		//Slide,
		SweetModal,
	},
	props: {
		periodoSelecionado: {
			default: 0,
			type: Number,
		},
		forcarRenderizacao: {
			default: 0,
			type: Number,
		},
	},
	computed: {
		dataReferencia() {
			let datas = this.$store.getters.getDatasPeriodo;
			return moment(datas.maiorData ?? new Date()).format("YYYY-MM-DD");
		},
		dark() {
			return this.$route.query.dark;
		},
		modalTheme() {
			return this.dark ? "dark" : "";
		},
	},
	data() {
		return {
			periodos: [
				"Mês",
				"Ano",
				"12 meses",
				"24 meses",
				"36 meses",
				"Desde o inicio",
			],
			ativoSelecionado: {
				codigoAtivo: 0,
				nomeAtivo: "",
				valorAplicado: 0,
				participacao: 0,
				rentabilidadeMes: 0,
				rentabilidadeAno: 0,
				rentabilidade3Meses: 0,
				rentabilidade6Meses: 0,
				rentabilidade12Meses: 0,
				rentabilidade24Meses: 0,
				rentabilidade36Meses: 0,
				rentabilidade48Meses: 0,
				rentabilidade60Meses: 0,
				rentabilidadeDesdeInicio: 0,
				nomeIndexador: "",
				rentabilidadeIndexadorMes: 0,
				rentabilidadeIndexadorAno: 0,
				rentabilidadeIndexador3Meses: 0,
				rentabilidadeIndexador6Meses: 0,
				rentabilidadeIndexador12Meses: 0,
				rentabilidadeIndexador24Meses: 0,
				rentabilidadeIndexador36Meses: 0,
				rentabilidadeIndexador48Meses: 0,
				rentabilidadeIndexador60Meses: 0,
				rentabilidadeIndexadorDesdeInicio: 0,
			},
			ativos: [],
		};
	},
	beforeMount() {
		this.carregarDados();
	},
	methods: {
		carregarDados() {
			let indexadoresStore = this.$store.getters.getIndexadores;
			let ativosStore = this.$store.getters.getAtivos;
			let indexadores = indexadoresStore.reduce((arr, i) => {
				if (i.selecionado) arr.push(Number.parseInt(i.codigoIndexador))
				return arr
			}, [])

			for (let i = 0; i < ativosStore.length; i++) {
				if (ativosStore[i].selecionado) {
					indexadores.push(Number.parseInt(ativosStore[i].key));
				}
			}

			ComparadorService.obterRentabilidadesTabelaAtivos({
				token: this.$route.query.token,
				dataReferencia: this.dataReferencia,
				indexadores: indexadores,
			}).then((retorno) => {
				if (retorno.sucesso) {
					this.ativos = []
					for (let i = 0; i < retorno.rentabilidades.length; i++) {
						// A request SEMPRE retorna um indexador, fora os ativos
						// Se todos estiverem escondidos na store, aqui precisa refletir tbm
						const indx = retorno.rentabilidades[i]

						const indxStore = indexadoresStore.find(i => i.codigoAtivo == indx.codigoAtivo)

						if (!indxStore || indxStore.selecionado) {
							this.ativos.push({
								...retorno.rentabilidades[i],
								isIndexador: !!indxStore // Forçando valor boleano
							})
						}
					}
                    this.ativos.sort((a, b) => b.nomeAtivo - a.nomeAtivo || a.key - b.key)
					this.ativos.forEach(ativo => {
						ativo.cor = ColorsService.getIndexadorColor(ativo.nomeAtivo)
					})
				}
			})
		},
		formatarPorcentagem(numero) {
			return UtilsService.formatNumber(numero) + "%"
		},
		nomeAtivoMinimizado(nome) {
			return nome?.length > 22 ? nome.substring(0, 22) + "..." : nome
		},
		iconeStonksParaValor(valor) {
			return valor > 0 ? "/img/icons/ico-stonks.svg" : "/img/icons/ico-not-stonks.svg"
		},
		desativarRemocaoIndexador(codigo) {
			return this.$store.getters.getIndexadores.find(indx => indx.codigoIndexador == codigo)
		},
		confirmarRemocaoAtivo(item) {
			this.ativoSelecionado = item
			this.$refs.modalConfirmarRemocaoAtivo.open()
		},
		removerAtivo() {
			this.$refs.modalConfirmarRemocaoAtivo.close()
			SpinnerService.show()

			this.$store.commit("removeAtivo", this.ativoSelecionado.codigoAtivo)

			Vue.notify({
				title: "Sucesso",
				type: "success",
				group: "principal",
				text: "Ativo removido com sucesso.",
				duration: 5000,
			})

			this.$emit("acaoRealizada", "ativoRemovido")
			SpinnerService.hide()
		},
		highlightOnChart(seriesName, out = false) {
			this.$emit('highlightOnChart', seriesName, out)
		},
	},
	watch: {
		forcarRenderizacao: {
			handler(n, o) {
				this.carregarDados()
			},
			deep: true,
		},
	},
};
</script>

<style lang="scss">
.lista-rentabilidade-ativo {
	height: max-content;
	width: 100%;
	// max-width: 100vw;
	overflow: auto;
	table {
		thead tr {
			border-bottom: 1px solid $text-font-color;
		}
		tbody tr td {
			border-bottom: unset !important;
		}
	}
}
</style>